import { initialState } from 'bundles/requirements_set/requirements_constants';
import { merge } from 'lodash';
import { noFiltersApplied } from '../selectors/query';

export const CHANGE_PAGE = 'CHANGE_PAGE';
export function changePage(page) {
  return { page: page, type: CHANGE_PAGE };
}

export const CHANGE_SEARCH_TEXT = 'CHANGE_SEARCH_TEXT';
export function changeSearchText(text) {
  return { text, type: CHANGE_SEARCH_TEXT };
}

export const SELECT_INVESTMENT_TYPE = 'SELECT_INVESTMENT_TYPE';
export function selectInvestmentType(key, value) {
  return { id: key, value: value, type: SELECT_INVESTMENT_TYPE };
}

export const SELECT_TRANSACTION_TYPE = 'SELECT_TRANSACTION_TYPE';
export function selectTransactionType(key, value) {
  return { id: key, value: value, type: SELECT_TRANSACTION_TYPE };
}

export const SELECT_PROPERTY_TYPE = 'SELECT_PROPERTY_TYPE';
export function selectPropertyType(key, value) {
  return { id: key, value: value, type: SELECT_PROPERTY_TYPE };
}

export const CHANGE_ADDRESS_FILTER = 'CHANGE_ADDRESS_FILTER';
export function changeAddressFilter(addressFilter) {
  return { addressFilter: addressFilter, type: CHANGE_ADDRESS_FILTER };
}

export const CHANGE_PROPERTY_FILTER = 'CHANGE_PROPERTY_FILTER';
export function changePropertyFilter(propertyFilter) {
  return { propertyFilter: propertyFilter, type: CHANGE_PROPERTY_FILTER };
}

export const CHANGE_SORT = 'CHANGE_SORT';
export function changeSort(sort) {
  return { sort: sort, type: CHANGE_SORT };
}

export const SET_FULL_QUERY = 'SET_FULL_QUERY';
export const setFullQuery = query => (
  (dispatch, getState) => {
    // Reset state to initial state and merge the query
    const newQueryState = merge({}, getState().query, initialState, query);
    dispatch({ type: SET_FULL_QUERY, query: newQueryState });
  }
);
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export function clearFilters() {
  return { type: CLEAR_FILTERS };
}

export function clearFiltersIfEmpty() {
  return (dispatch, getState) => {
    if (noFiltersApplied(getState())) {
      dispatch(clearFilters());
    }
  };
}
